/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Filters } from './Filters'
import { PosOpeningTime } from './PosOpeningTime'
import { OverallOpeningTimes } from './OverallOpeningTimes'
import useUser from '../../Shared/UserProvider/useUser'
import { isProviderACompany } from '../../../services/Provider/Provider.service'
import useBreadcrumb from '../../NavBar/useBreadcrumb'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const OpeningTimes = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()
    const {user} = useUser()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, ...((isProviderACompany(user.provider) || user.isLoggedInOwnScope) ? [{
            text: t('home.submenus.paused'),
            link: true,
            path: '/analytics/openings/opening-activity',
        }] : []), {
            text: t('openings.openings_stats'),
            link: false,
        }])
    }, [setPaths, t, user.isLoggedInOwnScope, user.provider])

    return (
      <div>
          <div css={css`
              display: flex;
              align-items: center;
              
              & > a {
                  margin-top: .7rem;
              }
          `}>
              <Filters>
                  {(isProviderACompany(user.provider) || user.isLoggedInOwnScope) && <OverallOpeningTimes/>}
              </Filters>
          </div>

          <PosOpeningTime />
      </div>
    )
}

export { OpeningTimes }
